var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 3.33331C13.8333 2.87308 13.4602 2.49998 13 2.49998H3C2.53976 2.49998 2.16667 2.87308 2.16667 3.33331V16.6666C2.16667 17.1269 2.53976 17.5 3 17.5H13C13.4602 17.5 13.8333 17.1269 13.8333 16.6666V3.33331ZM15.5 16.6666C15.5 18.0474 14.3807 19.1666 13 19.1666H3C1.61929 19.1666 0.5 18.0474 0.5 16.6666V3.33331C0.5 1.9526 1.61929 0.833313 3 0.833313H13C14.3807 0.833313 15.5 1.9526 15.5 3.33331V16.6666Z",
    fill: "#FFA85D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionActive);
export default __webpack_public_path__ + "static/media/question_active.105cc08ce58d2e42f2335a32316a9494.svg";
export { ForwardRef as ReactComponent };